import { I18n } from 'react-redux-i18n';
import cx from 'classnames';

import { FieldSelector } from '@common/components/FieldSelector';
import { CONTEXT_TYPE_ALIAS_CONFIG } from '@modules/audit-report';
import { CONTEXT_TYPE } from '@modules/audit-report/constants/main';
import { FieldSelectorTrigger } from './components/field-selector-trigger';

import './updates.styles.scss';

export const Updates = (props) => {
  const { className, getFolders, getFields, value, onChange } = props;
  const [openedContextType, setOpenedContextType] = React.useState(); 

  const openIndividualFieldSelector = React.useCallback(() => setOpenedContextType(CONTEXT_TYPE.individual), []);
  const openPedigreeFieldSelector = React.useCallback(() => setOpenedContextType(CONTEXT_TYPE.pedigree), []);
  
  const closeFieldSelector = React.useCallback(() => setOpenedContextType(undefined), []);

  const handleGetFields = React.useCallback(({ folderId }) => {
    return getFields({ context: openedContextType, folderId });
  }, [getFields, openedContextType]);

  const handleGetFolders = React.useCallback(() => {
    return getFolders({ context: openedContextType });
  }, [getFolders, openedContextType]);

  const handleFieldChange = React.useCallback((type) => ({ field }) => {
    onChange({
      ...value,
      [CONTEXT_TYPE_ALIAS_CONFIG[type]]: {
        ...value[CONTEXT_TYPE_ALIAS_CONFIG[type]],
        value: field,
      }
    });
  }, [value, onChange]);

  const handleUseStateChange = React.useCallback((_, { e }) => {
    e.persist();

    const { dataset: { type } } = e.currentTarget;
    const isChecked = !value[CONTEXT_TYPE_ALIAS_CONFIG[type]].use;

    onChange({
      ...value,
      [CONTEXT_TYPE_ALIAS_CONFIG[type]]: {
        ...value[CONTEXT_TYPE_ALIAS_CONFIG[type]],
        use: isChecked,
      }
    });
  }, [value, onChange]);

  return (
    <section className={cx('FieldAuditReportUpdates', className)}>
      <h6 className="FieldAuditReportUpdates__title">{I18n.t('Show Updates for:')}</h6>
      {openedContextType === CONTEXT_TYPE.individual && (
        <FieldSelector 
          getFolders={handleGetFolders}
          getFields={handleGetFields}
          onChange={handleFieldChange(CONTEXT_TYPE.individual)}
          close={closeFieldSelector}
        />
      )}
      {openedContextType === CONTEXT_TYPE.pedigree && (
        <FieldSelector 
          getFolders={handleGetFolders}
          getFields={handleGetFields}
          onChange={handleFieldChange(CONTEXT_TYPE.pedigree)}
          close={closeFieldSelector}
        />
      )}
      <div>
        <FieldSelectorTrigger
          contextType={CONTEXT_TYPE.individual}
          indicator="Individual Data"
          name={value.individual.value?.fieldName}
          fieldId={value.individual.value?.fieldId}
          use={value.individual.use}
          imageURL={value.individual.value?.imageURL}
          onUseChange={handleUseStateChange}
          onOpenSelector={openIndividualFieldSelector}
        />
        <FieldSelectorTrigger 
          contextType={CONTEXT_TYPE.pedigree}
          indicator="Pedigree Data"
          name={value.pedigree.value?.fieldName}
          fieldId={value.pedigree.value?.fieldId}
          use={value.pedigree.use}
          imageURL={value.pedigree.value?.imageURL}
          onUseChange={handleUseStateChange}
          onOpenSelector={openPedigreeFieldSelector}
        />
      </div>
    </section>
  );
};